import { memoize } from 'lodash'
import CartItemViewModel from './CartItemViewModel'

const CartItemsViewModel = memoize((cartItems) => cartItems.map(CartItemViewModel))

export default CartItemsViewModel
